import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2, Loader2, StickyNote } from "lucide-react";
import { formatApiError } from "@/pages/AdminLogin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => new Date(iso).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" });

export const InquiryNotes = ({ q, onChange }) => {
  const [text, setText] = useState("");
  const [author, setAuthor] = useState(() => localStorage.getItem("aufbruchwerk-author") || "Sanaz");
  const [saving, setSaving] = useState(false);
  const notes = Array.isArray(q.notes) ? q.notes : [];

  const pick = (a) => { setAuthor(a); localStorage.setItem("aufbruchwerk-author", a); };

  const add = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/admin/inquiries/${q.id}/notes`, { text, author }, { withCredentials: true });
      onChange([...notes, data]);
      setText("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const remove = async (id) => {
    try {
      await axios.delete(`${API}/admin/inquiries/${q.id}/notes/${id}`, { withCredentials: true });
      onChange(notes.filter((n) => n.id !== id));
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="mt-6 rounded-[2px] border border-[var(--line)] bg-white/60 p-4" data-testid={`inquiry-notes-${q.id}`}>
      <p className="font-mono-d flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[var(--ink-2)]"><StickyNote className="h-3.5 w-3.5" /> Interne Notizen ({notes.length})</p>
      {notes.length > 0 && (
        <ul className="mt-3 space-y-3">
          {notes.map((n) => (
            <li key={n.id} className="group flex items-start justify-between gap-3 border-l-2 border-[var(--clay)] pl-3" data-testid={`note-${n.id}`}>
              <div>
                <p className="whitespace-pre-line text-sm text-[var(--ink)]">{n.text}</p>
                <p className="font-mono-d mt-1 text-[11px] text-[var(--ink-2)]">{n.author} · {fmt(n.created_at)}</p>
              </div>
              <button onClick={() => remove(n.id)} aria-label="Notiz löschen" data-testid={`note-delete-${n.id}`} className="p-1 text-[var(--ink-2)] transition-colors hover:text-[#B42318]"><Trash2 className="h-4 w-4" /></button>
            </li>
          ))}
        </ul>
      )}
      <form onSubmit={add} className="mt-4">
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="z. B. Rückruf am Do. 14 Uhr, Unterlagen anfordern …" data-testid={`note-input-${q.id}`} className="w-full resize-none rounded-[2px] border border-[var(--line)] bg-[var(--stone)] p-3 text-sm outline-none focus:border-[var(--clay)]" />
        <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
          <div className="flex gap-1">
            {["Sanaz", "Ghassem"].map((a) => (
              <button type="button" key={a} onClick={() => pick(a)} data-testid={`note-author-${a.toLowerCase()}-${q.id}`} className={`rounded-full px-3 py-1 text-xs transition-[background-color,color] duration-300 ${author === a ? "bg-[var(--ink)] text-[var(--stone)]" : "text-[var(--ink-2)] hover:bg-[var(--ink)]/5"}`}>{a}</button>
            ))}
          </div>
          <button type="submit" disabled={saving || !text.trim()} data-testid={`note-save-${q.id}`} className="flex items-center gap-2 rounded-full border border-[var(--ink)]/25 px-4 py-1.5 text-xs transition-[border-color] hover:border-[var(--ink)] disabled:opacity-40">
            {saving && <Loader2 className="h-3 w-3 animate-spin" />} Notiz speichern
          </button>
        </div>
      </form>
    </div>
  );
};
